import Proptype from 'prop-types';
import { UserInfoCardContainer } from './styles';

export const UserInfoCard = ({ color, text, title, margin, marginLeft }) => {
  return (
    <UserInfoCardContainer variant={color} margin={margin} marginLeft={marginLeft}>
      <h4 className="title">{title}</h4>
      <p className="text">{text}</p>
    </UserInfoCardContainer>
  );
};

UserInfoCard.propTypes = {
  color: Proptype.string,
  text: Proptype.string,
  title: Proptype.string,
  margin: Proptype.string,
  marginLeft: Proptype.string,
};
